import { withDependencies } from '@wix/thunderbolt-ioc'
import { CurrentRouteInfoSymbol } from '@wix/thunderbolt-symbols'
import type { CandidateRouteInfo, ICurrentRouteInfo, IRouterContext, IRoutingValidation } from '../types'
import { RouterContextSymbol } from '../symbols'

export const RoutingValidation = withDependencies(
	[CurrentRouteInfoSymbol, RouterContextSymbol],
	(currentRouteInfoApi: ICurrentRouteInfo, routerContext: IRouterContext): IRoutingValidation => {
		return {
			isSamePageUrl(currentRouteUrl: string, nextUrl: string) {
				const currentRouteInfo = currentRouteInfoApi.getCurrentRouteInfo() as CandidateRouteInfo
				return (
					// This will recognize page changes
					currentRouteUrl === nextUrl &&
					// This will recognize change to preview/editor and mobile/desktop
					routerContext.getRouteInfoContext(currentRouteInfo) === currentRouteInfo.contextId
				)
			},
			isTpaSamePageNavigation(currentRouteInfo: CandidateRouteInfo, nextRouteInfo: CandidateRouteInfo) {
				return (
					currentRouteInfo?.pageId === nextRouteInfo.pageId &&
					currentRouteInfo?.contextId === nextRouteInfo.contextId &&
					nextRouteInfo.type === 'Static' &&
					currentRouteInfo?.type !== 'Dynamic'
				)
			},
		}
	}
)
